// eslint-disable-next-line no-shadow
export var IPublicEnumDragObjectType = /*#__PURE__*/function (IPublicEnumDragObjectType) {
  IPublicEnumDragObjectType["Node"] = "node";
  IPublicEnumDragObjectType["NodeData"] = "nodedata";
  return IPublicEnumDragObjectType;
}({});

/**
 * @deprecated use IPublicEnumDragObjectType instead
 */
export var DragObjectType = /*#__PURE__*/function (DragObjectType) {
  DragObjectType["Node"] = "node";
  DragObjectType["NodeData"] = "nodedata";
  return DragObjectType;
}({});